import IndexLayout from "../Layouts/IndexLayout";
import MainLayout from "../Layouts/MainLayout";
import PagesLayaut from '../Layouts/PagesLayaut'
import React, { Suspense, lazy } from 'react';
import { createBrowserRouter } from "react-router-dom";
const Productos = lazy(()=> import('../Pages/Productos/Productos'));
const Usuarios = lazy(()=> import('../Pages/Usuarios/Usuarios'));
const Banners = lazy(()=> import('./Banners/Banners'));
const MasProductos = lazy(()=> import('./MasProductos/MasProductos'));
const Main = lazy(()=> import('./Main/Main'));
const Categorias = lazy(()=> import('./Categorias/Categorias'));
const Codigos = lazy(()=> import('./Codigos/Codigos'));
const Flyers = lazy(()=> import('./Flyers/Flyers'));
const ReviewsData = lazy(()=> import('../Components/Admin/ReviewsData/ReviewsData'));
const PageDetail = lazy(()=> import('../Pages/PageDetail/PageDetail'));
const PageProductos = lazy(()=> import('./PageProductos/PageProductos'));
const Pedidos = lazy(()=> import('./Pedidos/Pedidos'));
const Tienda = lazy(()=> import('./Tienda/Tienda'));
const MetodosDePago = lazy(()=> import('./MetodosDePago/MetodosDePago'));
const Suscriptores = lazy(()=> import('./Suscriptores/Suscriptores'));
const FooterLinks = lazy(()=> import('./FooterLinks/FooterLinks'));
const FooterPages = lazy(()=> import('./FooterPages/FooterPages'));
const SEOSettings = lazy(()=> import('../Components/Admin/SEOSettings/SEOSettings'));
const PixelMetaSettings = lazy(()=> import('../Components/Admin/PixelMeta/PixelMetaSettings'));
const BlocksData = lazy(()=> import('../Components/Admin/BlocksData/BlocksData'));
const SobreNosotros = lazy(()=> import('./SobreNosotros/SobreNosotros'));
const Servicios = lazy(()=> import('./Servicios/Servicios'));
const Faqs = lazy(()=> import('./Faqs/Faqs'));
const Contacto = lazy(()=> import('./Contacto/Contacto'));
export const router = createBrowserRouter([

    {
        path: "/",
        element: <IndexLayout />,

    },
    {
        path: "/",
        element: <PagesLayaut />,
        children: [
            {
                path: `/producto/:idProducto/:producto`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><PageDetail /></Suspense>),
            },
            // 2. AÑADE LA NUEVA RUTA AQUÍ
            {
                path: `/productos`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><PageProductos /></Suspense>),
            },
            { path: `/sobre-nosotros`, element: (<Suspense fallback={<div className='loadingRoute'/>}><SobreNosotros /></Suspense>) },
            { path: `/servicios`, element: (<Suspense fallback={<div className='loadingRoute'/>}><Servicios /></Suspense>) },
            { path: `/faqs`, element: (<Suspense fallback={<div className='loadingRoute'/>}><Faqs /></Suspense>) },
            { path: `/contacto`, element: (<Suspense fallback={<div className='loadingRoute'/>}><Contacto /></Suspense>) },
        ]
    },
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                path: `/dashboard`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><Main /></Suspense>),
            },
            {
                path: `/dashboard/productos`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><Productos /></Suspense>),
            },
            {
                path: `/dashboard/usuarios`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><Usuarios /></Suspense>),
            },
            {
                path: `/dashboard/banners`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><Banners /></Suspense>),
            },

            {
                path: `/dashboard/flyers`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><Flyers /></Suspense>),
            },
            {
                path: `/dashboard/reseñas`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><ReviewsData /></Suspense>),
            },

            {
                path: `/dashboard/mas-productos`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><MasProductos /></Suspense>),
            },

            {
                path: `/dashboard/categorias`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><Categorias /></Suspense>),
            },

            {
                path: `/dashboard/promociones`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><Codigos /></Suspense>),
            },
            {
                path: `/dashboard/pedidos`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><Pedidos /></Suspense>),
            },
            {
                path: `/dashboard/pedidos/view`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><Pedidos /></Suspense>),
            },
            {
                path: `/dashboard/mi-tienda`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><Tienda /></Suspense>),
            },
            {
                path: `/dashboard/metodos-de-pago`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><MetodosDePago /></Suspense>),
            },

            {
                path: `/dashboard/suscriptores`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><Suscriptores /></Suspense>),
            },
            {
                path: `/dashboard/footer`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><FooterLinks /></Suspense>),
            },
            {
                path: `/dashboard/footer-paginas`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><FooterPages /></Suspense>),
            },
            {
                path: `/dashboard/seo`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><SEOSettings /></Suspense>),
            },
            {
                path: `/dashboard/pixel`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><PixelMetaSettings /></Suspense>),
            },
            {
                path: `/dashboard/bloqueos`,
                element: (<Suspense fallback={<div className='loadingRoute'/>}><BlocksData /></Suspense>),
            },
        ],
    },
  ],
  // --- Configuración Adicional del Router ---
  {
    //basename: "/Shop", // ✨ ¡AQUÍ ESTÁ LA CONFIGURACIÓN! ✨
  }
);
